import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, NavLink } from 'react-router-dom';
import Logo from './Logo';

function NavBar() {
  return (
    <Navbar expand="lg" className="siteNav">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <Logo className="siteLogo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav className="gap-1">
            <NavLink className="nav-link" to="/" end>Home</NavLink>
            <NavLink className="nav-link" to="/news">News</NavLink>
            <NavLink className="nav-link" to="/tips">Tips</NavLink>
            <NavLink className="nav-link" to="/deals">Deals</NavLink>
            <NavLink className="nav-link" to="/aboutUs">About Us</NavLink>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
